module.exports = __webpack_public_path__ + "img/example-1.3a872213.png";